const agreement = {
  state: {
    code: ''
  },
  mutations: {
    SET_CODE: function (state, config) {
      state.code = config
    }
  },
  actions: {
    setCode({commit}, config) {
      commit('SET_CODE', config)
    }
  }
}
export default agreement
